import { IconButton, Tooltip } from "@mui/material";
import DataGridCustom from "../General/DatagridCustom";
import { useAuth } from "../../context/AuthContext";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";

export default function RolesTable({
  roles,
  onEdit,
  onDelete,
  loading = false,
}) {
  const { hasPermission } = useAuth();

  const columns = [
    { field: "name", headerName: "Rol", flex: 2 },
    {
      field: "permissions",
      headerName: "Permisos",
      flex: 4,
      renderCell: (params) => {
        const permissions = params.row.permissions || [];
        const text = permissions.map((p) => p.name).join(", ");
        const shortText =
          permissions.length > 3
            ? permissions
                .slice(0, 3)
                .map((p) => p.name)
                .join(", ") + "..."
            : text;

        return (
          <Tooltip title={text} arrow>
            <span>{shortText}</span>
          </Tooltip>
        );
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      flex: 1,
      renderCell: (params) => (
        <>
          <IconButton
            onClick={() => onEdit(params.row)}
            color="primary"
            disabled={
              !hasPermission("actualizar roles") || params.row.name === "admin"
            }
          >
            <EditIcon />
          </IconButton>
          <IconButton
            onClick={() => onDelete(params.row.id)}
            color="error"
            disabled={
              !hasPermission("eliminar roles") || params.row.name === "admin"
            }
          >
            <DeleteIcon />
          </IconButton>
        </>
      ),
    },
  ];

  return (
    <div style={{ height: 500, width: "100%" }}>
      <DataGridCustom
        rows={roles}
        title="Listado de Roles"
        description="Administrar los roles registrados."
        icon={<SupervisedUserCircleIcon sx={{ fontSize: 32 }} />}
        columns={columns}
        pageSize={10}
        getRowId={(row) => row.id}
        loading={loading}
      />
    </div>
  );
}
